<template>
    <el-container>
        <el-header>
            <Header></Header>
        </el-header>
        <el-main>
            <router-view></router-view>
            
        </el-main>
        <el-footer>
            <Footer></Footer>
        </el-footer>
    </el-container>
    
</template>
<script>
    import Header from './header.vue'
    import Footer from './footer.vue'
    
    export default{
        components:{
            Header,
            Footer
        },
        mounted(){
            
        }
    
    }
</script>
<style lang="scss">
    .el-container .el-header{
        padding: 0;
    }
    .el-container .el-main{
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/header/layout.vue